/**
 * Created by Ning Jiang on 6/25/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {Power2, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {FruitsLayerConfig} from "../../../../config/FruitsLayerConfig";
import {FruitsStrings} from "../../../../config/FruitsStrings";
import {FruitsTextStyles} from "../../../../config/FruitsTextStyles";
import {FruitsGameModuleConfig} from "../../../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../../../FruitsSoundConfig";
import {FruitsGameMode} from "../../../gamemode/FruitsGameMode";
import {FruitsParsedGameData} from "../../../server/data/FruitsParsedGameData";
import {FruitsParsedInitData} from "../../../server/data/FruitsParsedInitData";
import {FruitsHelper} from "../../../utils/FruitsHelper";
import {BonusGameScreenView} from "../BonusGameScreenView";

export class BonusGameIntroView extends BonusGameScreenView {
    private _container:PIXI.Container;
    private _b1:PIXI.Sprite;
    private _b2:PIXI.Sprite;
    private _scatterText:PIXI.Text;
    private _scatterTextBg:PIXI.Sprite;
    private _extraSpinText:PIXI.Text;
    private _upgradeText:PIXI.Text;
    private _getMultiplierText:PIXI.Text;
    private _introTl:TimelineLite;
    private _scattersArray:PIXI.Sprite[];
    private _scatterContainer:PIXI.Container;
    private _orientation:string = Orientation.LANDSCAPE;
    private _indicatorInitialized:boolean = false;
    private _highOrderLayer:ScalableLayer;
    private _reels:string[];

    public static readonly START_BONUS_INTRO_PRES:string = "bonusGameIntroView_startBonusIntroPres";

    constructor(config:IScreenViewConfig, autoClose:boolean = false) {
        super(config, autoClose);
        this._highOrderLayer = StageManager.getLayer(FruitsLayerConfig.HIGH_ORDER_LAYER.name);
    }

    protected addEventListeners() {
        super.addEventListeners();
        EventHandler.addEventListener(this, BonusGameIntroView.START_BONUS_INTRO_PRES, () => this.startAnimation());
    }

    protected getNewMode():string {
        return FruitsGameMode.BONUS_GAME;
    }

    protected initAnimations() {
        this._container = new PIXI.Container();
        this._highOrderLayer.addChild(this._container);

        this._scatterContainer = new PIXI.Container();
        this._layer.addChild(this._scatterContainer);

        this._introTl = new TimelineLite();

        this._scattersArray = [];

        this.createGraphics();

        super.initAnimations();
    }

    protected startPresentation(data?:FruitsParsedGameData | FruitsParsedInitData, onShowComplete?:() => void):void {

        this.createScatterSprites(this.parseReelsEnteringBonus(data!.reelsEnteringBonus));

        super.startPresentation(data, onShowComplete);
    }

    private parseReelsEnteringBonus(reelsEnteringBonus:string[][]):string[][] {
        let parsedSymbols = [];
        for(let i = 0; i < reelsEnteringBonus.length; i++) {
            for(let j = 0; j < reelsEnteringBonus[i].length; j++) {
                if(i === 0 && j === 0 || i === 1 && j === 0) {
                    continue;
                }
                parsedSymbols.push([reelsEnteringBonus[i][j]]);
            }
        }
        return parsedSymbols;
    }

    private createScatterSprites(reels:string[][]) {
        this._reels = [];
        for(let i:number = 0; i < reels.length; i++) {
            this._reels.push(reels[i][0]);

            if(reels[i][0] === "S") {
                let symInd:[number, number] = FruitsHelper.translateReelIndex(i);
                let rectPos:number[] = FruitsHelper.getSymbolPosition(symInd[0], symInd[1], this._orientation, FruitsGameMode.BONUS_GAME);

                const scatter = new PIXI.Sprite(GameResources.getTextures("S_normal")[0]);
                scatter.anchor.set(0.5, 0.5);
                scatter.alpha = 0;
                //TODO-hevar: chech this pixel offsets.
                if(this._orientation === Orientation.PORTRAIT)
                    scatter.position.set(rectPos[0] - 5, rectPos[1] - 3);
                else
                    scatter.position.set(rectPos[0] - 2, rectPos[1] - 1);

                this._scatterContainer.addChild(scatter);
                this._scattersArray.push(scatter);
            }
        }

    }

    private createGraphics():void {

        this._b1 = new PIXI.Sprite(GameResources.getTextures("B1_normal")[0]);
        this._b1.anchor.set(0.5, 0.5);
        this._b1.alpha = 0;
        this._b1.position.set(870, 250);

        this._b2 = new PIXI.Sprite(GameResources.getTextures("B2_normal")[0]);
        this._b2.anchor.set(0.5, 0.5);
        this._b2.alpha = 0;
        this._b2.position.set(870, 430);

        this._scatterTextBg = new PIXI.Sprite(GameResources.getTextures("scatter_text_bg")[0]);
        this._scatterTextBg.anchor.set(0.5, 0.5);
        this._scatterTextBg.alpha = 0;
        this._scatterTextBg.position.set(400, 355);

        this._scatterText = new PIXI.Text(` ${Translation.translate(FruitsStrings.COLLECT_SCATTERS)} `, FruitsTextStyles.BONUS_INTRO_SCATTER);
        this._scatterText.anchor.set(0.5, 0.5);
        this._scatterText.alpha = 0;
        this._scatterText.position.set(400, 355);

        this._extraSpinText = new PIXI.Text(` ${Translation.translate(FruitsStrings.EXTRA_SPIN)} `, FruitsTextStyles.BONUS_INTRO);
        this._extraSpinText.anchor.set(0.5, 0.5);
        this._extraSpinText.alpha = 0;
        this._extraSpinText.position.set(1030, 245);

        this._upgradeText = new PIXI.Text(` ${Translation.translate(FruitsStrings.UPGRADE)} `, FruitsTextStyles.BONUS_INTRO);
        this._upgradeText.anchor.set(0.5, 0.5);
        this._upgradeText.alpha = 0;
        this._upgradeText.position.set(1030, 425);

        this._getMultiplierText = new PIXI.Text(` ${Translation.translate(FruitsStrings.GET_LEVEL_UP)} `, FruitsTextStyles.BONUS_INTRO_WW);
        this._getMultiplierText.anchor.set(1, 0.5);
        this._getMultiplierText.alpha = 0;
        this._getMultiplierText.position.set(1170, 580);


        this._container.addChild(this._scatterTextBg);
        this._container.addChild(this._b1);
        this._container.addChild(this._b2);
        this._container.addChild(this._scatterText);
        this._container.addChild(this._extraSpinText);
        this._container.addChild(this._upgradeText);
        this._container.addChild(this._getMultiplierText);

    }

    private scatterAnimation():TimelineLite {

        const tl:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < this._scattersArray.length; i++) {
            tl.add(() => {this._scattersArray[i].alpha = 1;});
        }

        return tl;

    }

    public startAnimation():void {
        this._container.alpha = 1;

        this._introTl.add([
            this.scatterAnimation(),
            () => SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_INFO_PLING),
            TweenLite.to(this._scatterText, 0.5, {alpha : 1}),
            TweenLite.to(this._scatterTextBg, 0.5, {alpha : 1})
        ]);

        this._introTl.add([
            TweenLite.to(this._getMultiplierText, 0.5, {alpha : 1}),
            () => this.initIndicator(),
        ]);

        this._introTl.add([
            TweenLite.to(this._b1, 0.5, {alpha : 1}),
            () => SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_INFO_PLING),
            TweenLite.to(this._extraSpinText, 0.5, {alpha : 1})
        ], "+= 0.5");

        this._introTl.add([
            TweenLite.to(this._b2, 0.5, {alpha : 1}),
            () => SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_INFO_PLING),
            TweenLite.to(this._upgradeText, 0.5, {alpha : 1}),
        ], "+= 0.5");

        this._introTl.add(this.idleLoop());


    }

    private initIndicator():void {
        if(!this._indicatorInitialized) {
            FruitsGameModuleConfig.bonusOverlayView.initIndicator();
            this._indicatorInitialized = true;
        }
    }

    private idleLoop():TimelineLite {
        const tl:TimelineMax = new TimelineMax({repeat : 3, repeatDelay : 3});
        this._scattersArray.map((scatter, index) => {
            const scatterTl:TimelineLite = new TimelineLite();
            scatterTl.add(TweenLite.to(scatter.scale, 0.185, {x : 1.2, y : 1.2, ease : Power2.easeOut}));
            scatterTl.add(TweenLite.to(scatter.scale, 0.095, {x : 0.9, y : 0.9, ease : Power2.easeOut}));
            scatterTl.add(TweenLite.to(scatter.scale, 0.22, {x : 1, y : 1, ease : Power2.easeOut}));

            tl.add(scatterTl, 0);
        });
        tl.add(() => SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_INFO_PLING), 0);

        tl.add([
            TweenLite.to(this._b1.scale, 0.185, {x : 1.2, y : 1.2, ease : Power2.easeOut}),
            () => SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_INFO_PLING)
        ], "+= 1");
        tl.add(TweenLite.to(this._b1.scale, 0.095, {x : 0.9, y : 0.9, ease : Power2.easeOut}));
        tl.add(TweenLite.to(this._b1.scale, 0.22, {x : 1, y : 1, ease : Power2.easeOut}));

        tl.add([
            TweenLite.to(this._b2.scale, 0.185, {x : 1.2, y : 1.2, ease : Power2.easeOut}),
            () => SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_INFO_PLING)
        ], "+= 1");
        tl.add(TweenLite.to(this._b2.scale, 0.095, {x : 0.9, y : 0.9, ease : Power2.easeOut}));
        tl.add(TweenLite.to(this._b2.scale, 0.22, {x : 1, y : 1, ease : Power2.easeOut}));

        return tl;
    }

    private endAnimation():void {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this.resetGraphics(), 0);
        tl.add(TweenLite.to(this._container, 0.5, {alpha : 0}), .1);

    }

    private resetGraphics():void {
        this._scattersArray = [];
        this._scatterContainer.removeChildren();
        this._b1.alpha = 0;
        this._b2.alpha = 0;
        this._scatterText.alpha = 0;
        this._scatterTextBg.alpha = 0;
        this._extraSpinText.alpha = 0;
        this._upgradeText.alpha = 0;
        this._getMultiplierText.alpha = 0;

    }

    protected stopPresentation(closeCallback?:() => void):void {
        if(this._introTl.isActive()) {
            this._introTl.kill();
            this._introTl.clear();
        }

        this.endAnimation();
        FruitsGameModuleConfig.bonusOverlayView.removeIndicatorFromIntro();
        this._indicatorInitialized = false;
        super.stopPresentation(closeCallback);
    }

    protected onResize(resizeData:IResizeData):void {

        if(this._reels && this._scattersArray.length > 0) {
            let rInd:number = 0, scatterIndex:number = 0;
            this._reels.forEach((sym) => {
                if(sym.substr(0, 1) === "S") {
                    let symInd:[number, number] = FruitsHelper.translateReelIndex(rInd);
                    let rectPos:number[] = FruitsHelper.getSymbolPosition(symInd[0], symInd[1], resizeData.orientation, FruitsGameMode.BONUS_GAME);
                    if(resizeData.orientation === Orientation.PORTRAIT)
                        this._scattersArray[scatterIndex].position.set(rectPos[0] - 5, rectPos[1] - 3);
                    else
                        this._scattersArray[scatterIndex].position.set(rectPos[0] - 2, rectPos[1] - 1);
                    scatterIndex++;
                }
                rInd++;
            });
        }

        if(resizeData.orientation === Orientation.PORTRAIT) {

            this._orientation = Orientation.PORTRAIT;
            this._b1.position.set(480, 630);
            this._b2.position.set(480, 810);
            this._scatterText.position.set(570, 165);
            this._scatterTextBg.position.set(570, 165);
            this._extraSpinText.position.set(480, 700);
            this._upgradeText.position.set(480, 880);
            this._getMultiplierText.position.set(880, 810);
            this._extraSpinText.anchor.set(0.5, 0.5);
            this._upgradeText.anchor.set(0.5, 0.5);

        } else {
            this._orientation = Orientation.LANDSCAPE;
            this._b1.position.set(870, 250);
            this._b2.position.set(870, 430);
            this._scatterText.position.set(400, 355);
            this._scatterTextBg.position.set(400, 355);
            this._getMultiplierText.position.set(1170, 580);
            this._upgradeText.position.set(780, 495);
            this._upgradeText.anchor.set(0, 0.5);
            this._extraSpinText.position.set(780, 315);
            this._extraSpinText.anchor.set(0, 0.5);

        }


        super.onResize(resizeData);

    }

    public get indicatorInitialized():boolean {
        return this._indicatorInitialized;
    }

}